/**
 * @generated SignedSource<<927f1e4e0f2860216aa0312340536e5d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type composerQueriesCheckAiLimitQuery$variables = Record<PropertyKey, never>;
export type composerQueriesCheckAiLimitQuery$data = {
  readonly checkAILimited: boolean;
};
export type composerQueriesCheckAiLimitQuery = {
  response: composerQueriesCheckAiLimitQuery$data;
  variables: composerQueriesCheckAiLimitQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "checkAILimited",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "composerQueriesCheckAiLimitQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "composerQueriesCheckAiLimitQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "d6f43e0056c13b02ac10eaa33f3fa07a",
    "id": null,
    "metadata": {},
    "name": "composerQueriesCheckAiLimitQuery",
    "operationKind": "query",
    "text": "query composerQueriesCheckAiLimitQuery {\n  checkAILimited\n}\n"
  }
};
})();

(node as any).hash = "5f9f37befc6cec4d6e3ad3bd672c5a15";

export default node;
